import type { ApiType } from 'types/api_type';

export const organizationAdminsApi: Readonly<ApiType> = {
  path: '/organization_admins',
};

export const organizationAdminsFindPath = (id: string): string => {
  return `${organizationAdminsApi.path}/${id}`;
};

export const organizationAdminsUpdatePath = (id: string): string => {
  return `${organizationAdminsApi.path}/${id}`;
};

export const organizationAdminsDeletePath = (id: string): string => {
  return `${organizationAdminsApi.path}/${id}`;
};

export const organizationAdminsReInvitePath = (id: string): string => {
  return `${organizationAdminsApi.path}/${id}/re_invite`;
};

export const organizationAdminsDevolvePath = (id: string): string => {
  return `${organizationAdminsApi.path}/${id}/devolve`;
};
